import { call, put, select } from 'typed-redux-saga'

import { showError } from '@store/ui/error/actions'
import { setLastServiceResponse } from '@store/session/actions'
import { ApplicationState } from '@store/types'
import { StepRefin } from '@utils/enums'
import { HttpStatus } from '@services/base'
import services from '@services'
import { BridgeService } from '@services/bridge'
import { logout } from '@utils/functions'
import { ErroType } from '@utils/types'

import { getValidateBiometrics, setLoadingBimetricsValidate } from '../actions'

interface Props {
  payload: {
    callback: (isValid: boolean) => void
  }
  type: string
}

export default function* getBiometricsValidateSaga({ payload }: Props) {
  const { biometricToken } = yield* select((s: ApplicationState) => s.biometria)
  const { accessToken } = yield* select((s: ApplicationState) => s.session)

  yield put(setLoadingBimetricsValidate(true))

  try {
    const service = BridgeService.isBrowser()
      ? services.getBiometricsValidateWebService
      : services.getBiometricsValidateAppService

    const { data } = yield* call(service, biometricToken, accessToken)

    yield put(setLastServiceResponse({ code: 'OK', serviceName: 'getBiometricsValidateService' }))
    yield put(setLoadingBimetricsValidate(false))
    yield payload.callback(data.isValid)
  } catch (error) {
    yield put(
      setLastServiceResponse({ code: 'ERROR', serviceName: 'getBiometricsValidateService' }),
    )
    yield put(setLoadingBimetricsValidate(false))

    const erroTyped = error as ErroType

    if (BridgeService.isBrowser() && erroTyped.status === HttpStatus.UNAUTHORIZED) {
      yield put(
        showError({
          title: 'Sessão expirada',
          message: 'Efetue o login novamente.',
          actionTitle: 'Continuar',
          functionCallback: () => logout(),
        }),
      )
    } else {
      yield put(
        showError({
          title: 'Ocorreu um erro ao validar biometria',
          message: 'Por favor tente novamente.',
          actionTitle: 'Tentar Novamente',
          code: StepRefin.ERRO_VALIDAR_BIOMETRIA,
          actionCallback: () => getValidateBiometrics(payload),
          block: true,
        }),
      )
    }
  }
}
